import {Button, Image, Input, Toast} from "antd-mobile";
import '../../common/commonPayCs.css'
import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {TOASTDURATION} from "../../common/Utils";
import {paySumbit} from "../../common/ApiAction";

const OrangePay = () => {
    const [payId, setPayId] = useState(0)
    const [orderNo, setOrderNo] = useState<string>("")
    const [payAmount, setPayAmount] = useState<string>("")
    const [otpCode, setOtpCode] = useState<string>("")
    const [userName, setUserName] = useState<string>('')
    let location = useLocation();
    const navigate = useNavigate();

    useEffect(()=> {
        const data: any = location.state
        if (data) {
            setOrderNo(data.merchantTransactionId)
            setPayAmount(data.payAmount)
            setPayId(data.id)
            if (data.userName) {
                setUserName(data.userName)
            }
        }
    },[location.state])

    const sumbitAction = () => {
        if (!otpCode) {
            Toast.show({content: "Veuillez entrer otpcode", duration: TOASTDURATION})
            return
        }
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        paySumbit({payId, otpCode}).then((res: any) => {
            Toast.clear();
            navigate(-1)
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                Toast.show({icon: 'success', content: "Passer une commande avec succès", duration: TOASTDURATION})
            }
        })
    }

    return (
        <div style={{width: '100%', display: "flex", flexDirection: "column", alignItems: "center"}}>
            <div>
                <Image  src={require('../../assets/icon_ego_logo.jpg')} style={{width: 100}}/>
            </div>
            <div style={{borderRadius: 8, padding: '50px 0 20px 0', border: "solid #08ad58 1px", width: '90%', marginTop: 15, display: "flex", flexDirection: "column", alignItems: "center"}}>
                <span style={{fontSize: 20, fontWeight: "bold",marginBottom: 30, color: '#ffb32b'}}>Payer via Orange Money</span>
                <div className={'orange-item-box'} style={{justifyContent: "center", textAlign: "center", fontWeight: 500}}>
                    <span style={{fontWeight: 500}}>Rembourser pour le compte:</span>
                    <span style={{fontWeight: 500}}>{orderNo}</span>
                </div>
                {userName ?  <div className={'orange-item-box'}>
                    <span style={{fontWeight: "bold", fontSize: 15}}>Nom et prénom:</span>
                    <span style={{fontWeight: "bold", fontSize: 15, color: "red"}}>{userName}</span>
                </div> : null}
                <div className={'orange-item-box'}>
                    <span style={{fontWeight: "bold", fontSize: 15}}>Montant:</span>
                    <span style={{fontWeight: "bold", fontSize: 15, color: "red"}}>{payAmount} FCFA</span>
                </div>
                <div className={'orange-item-box'} style={{justifyContent: "center", textAlign: "center", fontWeight: 500}}>
                    <span style={{paddingLeft: 30, paddingRight: 30}}>Suivrez les érapes suivantes pour finaliser le paiement</span>
                </div>
                <div style={{width: '70%', marginTop: 30, marginBottom: 10}}>
                    <Input onChange={val => setOtpCode(val)} style={{"--font-size": '12px', width: '100%', border: "solid #cccccc 1px"}} placeholder='Code temporaire'/>
                </div>
                <div style={{justifyContent: "center", textAlign: "center", fontWeight: 500}}>
                    <div className={'orange-item-txt'}>1. Vérifier vorre numéro Orange Money</div>
                    <div className={'orange-item-txt'}>2. Générez un code de paiement depuis lapplicarion</div>
                    <div className={'orange-item-txt'}>Orange Money oucomposez le <span style={{color: '#ffb32b'}}>#144*82#</span></div>
                    <div className={'orange-item-txt'}>3. Saisissez le code de paiement obtenu puis cliquez sur confirmer</div>
                </div>
            </div>
            <div>
                <Button onClick={sumbitAction} shape='rounded' style={{backgroundColor: '#08ad58', color: '#FFF', marginTop: 50, paddingLeft: 30, paddingRight: 30}}>Confirmer et procéder</Button>
            </div>
        </div>
    )
}
export default OrangePay
